import { render, staticRenderFns } from "./noticeDetails.vue?vue&type=template&id=fc6a967c&scoped=true"
import script from "./noticeDetails.vue?vue&type=script&lang=js"
export * from "./noticeDetails.vue?vue&type=script&lang=js"
import style0 from "./noticeDetails.vue?vue&type=style&index=0&id=fc6a967c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6a967c",
  null
  
)

export default component.exports